import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';


import { CommonModule } from '@angular/common';
import { EfxAlertModule } from '@signal/component-library/efx-alert';

export interface ToastConfig {
  id: number;
  title?: string;
  type?: 'success' | 'error' | 'warning' | 'info' | 'default';
  description?: string;
  isClosable: boolean;
  duration: number; 
  mode?: 'component' | 'default';
  color?: string;
  maxWidth?: string;
  position?: ToastPosition;
}

export type ToastPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';

@Component({
    selector: 'app-notifications-alert',
    standalone: true,
    imports: [CommonModule, EfxAlertModule],
    templateUrl: './notifications-alert.component.html',
    styleUrl: './notifications-alert.component.scss',
    animations: []
})
export class NotificationsAlertComponent {
  @Input({ required: true }) config!: ToastConfig;
  @Output() close = new EventEmitter<number>();
  @HostBinding('class.w-100')
  isFullWidth = true;

  @HostBinding('style.maxWidth') get hostMaxWidth() {
    return this.config.maxWidth || '350px';
  }

 

  private timer: any;

  constructor() { }

  ngOnInit(): void {
    console.log('Datos recibidos en la alerta:', this.config);
    if (this.config.duration > 0) {
      this.timer = setTimeout(() => this.dismiss(), this.config.duration);
    } else {
      this.timer = setTimeout(() => this.dismiss(), 3000);
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }


  dismiss(): void {
    clearTimeout(this.timer); 
    this.close.emit(this.config.id);
  }


  getIcon(): string {
    switch (this.config.type) {
      case 'success': return 'check_circle';
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      case 'default': return '';
      default: return 'notifications';
    }
  }
}
